export const ORIGIN_TOKEN_HEADER = "x-mixitone-origin-token";
const ORIGIN_TOKEN_STORAGE_KEY = "mixitone-origin-token";

let moduleOriginToken: string | null = null;

function createOriginToken(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

/**
 * Returns a per-tab origin token for web sessions. Stored in sessionStorage so
 * separate tabs do not share a token and incorrectly ignore each other's broadcasts.
 */
export function getOrCreateClientOriginToken(): string {
  if (typeof sessionStorage !== "undefined") {
    const existing = sessionStorage.getItem(ORIGIN_TOKEN_STORAGE_KEY);
    if (existing) {
      moduleOriginToken = existing;
      return existing;
    }
    const token = createOriginToken();
    sessionStorage.setItem(ORIGIN_TOKEN_STORAGE_KEY, token);
    moduleOriginToken = token;
    return token;
  }

  if (!moduleOriginToken) {
    moduleOriginToken = createOriginToken();
  }
  return moduleOriginToken;
}

export function getClientOriginToken(): string | null {
  if (typeof sessionStorage !== "undefined") {
    return sessionStorage.getItem(ORIGIN_TOKEN_STORAGE_KEY) ?? moduleOriginToken;
  }
  return moduleOriginToken;
}

export function setClientOriginTokenForTests(token: string | null) {
  moduleOriginToken = token;
  if (typeof sessionStorage !== "undefined") {
    if (token) {
      sessionStorage.setItem(ORIGIN_TOKEN_STORAGE_KEY, token);
    } else {
      sessionStorage.removeItem(ORIGIN_TOKEN_STORAGE_KEY);
    }
  }
}

export function resetClientOriginTokenForTests() {
  setClientOriginTokenForTests(null);
}
